import { render, staticRenderFns } from "./RoleDialog.vue?vue&type=template&id=61af87db&"
import script from "./RoleDialog.vue?vue&type=script&lang=js&"
export * from "./RoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RoleDialog.vue"
export default component.exports